import { createFileRoute } from '@tanstack/react-router';
import DashboardComposer from '@/components/Dashboard/DashboardComposer';
import ContinueLearningSection from '@/components/Dashboard/ContinueLearningSection';
import SessionLibrary from '@/components/Dashboard/SessionLibrary';
import useUser from '@/hooks/useUser';
import { seesCandidateFeedback } from '@/lib/sessionCrm';

export const Route = createFileRoute('/_auth/dashboard')({
  component: DashboardPage,
});

function DashboardPage() {
  const { user } = useUser();
  return (
    <div className="space-y-10">
      <DashboardComposer />
      {!seesCandidateFeedback(user) && <ContinueLearningSection />}
      <SessionLibrary />
    </div>
  );
}
